import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const {
    user,
    isAdmin,
    isActive,
    roles,
    permissions,
    permissionList,
    loading,
    isAuthenticated,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  } = useAuth();

  const userName = user?.name || user?.email || 'User';
  const userEmail = user?.email;

  return {
    user,
    userName,
    userEmail,
    isAdmin,
    isActive,
    isAuthenticated,
    roles,
    permissions,
    permissionList,
    loading,
    hasPermission,
    hasAny: hasAnyPermission,
    hasAll: hasAllPermissions,
    hasAnyPermission,
    hasAllPermissions,
  };
};

export default usePermissions;
